/*
 * Baby registry — "Add to Babylist" handler.
 * Delegated click listener (attached once) reads product data from
 * data-* attributes and calls Babylist's bl.addToRegistry(). If the
 * Babylist SDK (babylist.com/add.js) hasn't loaded, the link's href
 * falls back to babylist.com.
 */
(function () {
  if (window.__parioRegistryInit) return;
  window.__parioRegistryInit = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-babylist-add]');
    if (!trigger) return;

    if (window.bl && typeof window.bl.addToRegistry === 'function') {
      event.preventDefault();

      // Close our drawer first — it's opened with showModal() and lives in the
      // browser's top layer, which would otherwise render above Babylist's popup.
      var dialog = trigger.closest('dialog');
      if (dialog && dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      }

      window.bl.addToRegistry({
        images: trigger.getAttribute('data-bl-image') || '',
        price: trigger.getAttribute('data-bl-price') || '',
        title: trigger.getAttribute('data-bl-title') || '',
        url: trigger.getAttribute('data-bl-url') || ''
      });
    }
    // else: allow the default href (babylist.com) as a fallback
  });
})();
